var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.loading)?_c('div',[_vm._v(" 正在等待渲染，请稍后 "),_c('p',[_vm._v("如长时间无法渲染，请刷新页面或返回重新打开")])]):_vm._e(),(!_vm.loading && _vm.printData && _vm.printData.id)?_c('button',{on:{"click":function($event){return _vm.sendBase64Img()}}},[_vm._v(" 下载图片 ")]):_vm._e(),_c('div',{attrs:{"id":"printView"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }